<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <b-tabs content-class="mt-3">

          <b-tab title="Job" active>
            <job-minimal :id="id"></job-minimal>

            <span v-if="!loading">
              
              <b-button
                variant="primary"
                @click="handleSubmit"
                class="float-right"
                >Reassess Job</b-button
              >
            </span>
            <span v-if="loading">
              <b-spinner label="Spinning"></b-spinner>
            </span>
          </b-tab>
       

          <b-tab title="Client" v-if="job.client_id">
            <client :id="job.client_id" class="mt-3"></client>
          </b-tab>

          <b-tab v-if="job.partner_id" title="Partner">
            <partner :id="job.partner_id" class="mt-3"></partner>
          </b-tab>

        
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jobRepo from "@/api/repos/jobRepo";
import partner from "@/views/modules/partners/show";
import client from "@/views/modules/clients/show";
import jobMinimal from "@/views/modules/jobs/enquiryMinimal";

export default {
  components: {
    partner,
    client,
    jobMinimal,
  },

  props: ["id"],

  mounted() {
    this.getCreatedData(this.id);
  },

  data() {
    return {      
      job: {},
      isLoad: false,
      loading: false,
      errors: null,
      submitStatus: null,
      
    };
  },

  methods: {
    async getCreatedData(id) {
      try {
        this.loading = true;
        let { data } = await jobRepo.reassessCreate(id);
        this.job = data.job;
     
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";

      try {
        await jobRepo.reassessStore({
          id: this.id,
        });
        this.$emit("reassessCreated");
      } catch (error) {
        console.log(error);
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;
          console.log(this.errors);
          this.$root.$bvToast.toast("Form Errors", {
            title: "Errors on form data",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      } finally {
        this.loading = false;
        this.submitStatus = null;
      }
    },
  },
};
</script>

